'use client';

import Script from 'next/script';
import { useEffect, useState } from 'react';
import { components } from '@/types/strapi';

export default function WhatsAppWidget({
	script,
}: {
	script: components['schemas']['Global']['freshworks'];
}) {
	const [loadScript, setLoadScript] = useState(false);

	// Validate required props
	if (!script?.script_src || !script?.data_widget_id) {
		console.warn('WhatsApp widget: Missing required configuration');
		return null;
	}

	useEffect(() => {
		if (typeof window === 'undefined') return;

		// Load widget when idle (if supported), else fallback to timeout
		const load = () => setLoadScript(true);
		if ('requestIdleCallback' in window) {
			requestIdleCallback(load);
		} else {
			setTimeout(load, 2000); // fallback after 2s
		}

		// (Optional) Long task logging for TBT insights
		const observer = new PerformanceObserver(list => {
			list.getEntries().forEach(entry => {
				if (entry.duration > 50) {
					console.warn('Long task detected:', entry);
				}
			});
		});

		observer.observe({ entryTypes: ['longtask'] });
		return () => observer.disconnect();
	}, []);

	if (!loadScript) return null;
	return (
		<Script
			id="fw-script"
			src={script.script_src}
			strategy="lazyOnload"
			defer
			data-chat={script.chat || true}
			data-widget-id={script.data_widget_id}
			onLoad={() => {
				console.log('WhatsApp widget loaded successfully');
			}}
			onError={e => {
				console.error('WhatsApp widget failed to load:', {
					error: e,
					config: {
						src: script.script_src,
						widgetId: script.data_widget_id,
						chat: script.chat,
					},
				});
			}}
		/>
	);
}
